import React, { Component } from 'react'
import { IMAGE_PREFIX } from '../../../../../constants/cloudinary'
import {
  StatItemContainer,
  StatsThumbnailVideo,
  StatDescriptionContainer,
  StatCount,
  StatDescription,
  StatsDescriptionHeading,
  StatsWrapper
} from './styledComponents'

class StatItem extends Component {
  render() {
    const { statData } = this.props

    const {
      statsImage,
      statsVideo,
      statsVideoMp4,
      statsVideoM2V,
      statsNumber,
      statsDescription,
      statsDescriptionHeading
    } = statData
    return (
      <StatItemContainer>
        <StatsThumbnailVideo
          autoPlay
          muted
          loop
          playsInline
          poster={`${IMAGE_PREFIX}${statsImage}`}
          data-keepplaying
          id="mautic-player-0"
          className="videoImage"
        >
          <source src={statsVideo} type="video/webm" />
          <source src={statsVideoMp4} type="video/mp4" />
          <source src={statsVideoM2V} type="video/m2v" />
          {/* TODO: M2V type I did get from internet. By a guess I kept it. Have to test it */}
        </StatsThumbnailVideo>

        <StatDescriptionContainer>
          <StatCount> {statsNumber}</StatCount>
          <StatsWrapper>
            <StatsDescriptionHeading>
              {statsDescriptionHeading}
            </StatsDescriptionHeading>

            <StatDescription>{statsDescription}</StatDescription>
          </StatsWrapper>
        </StatDescriptionContainer>
      </StatItemContainer>
    )
  }
}

export default StatItem



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/StatsSection/StatItem/index.js